import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { Router, RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { ENVIRONMENT } from "../../../environments/environment";
import { ApplicationService } from "../../services/application.service";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton, MatIcon, RouterLink, MatTooltip, AsyncPipe, TranslatePipe],
})
export class HeaderComponent {
  readonly applicationService = inject(ApplicationService);

  @Output()
  public openMenu = new EventEmitter();
  public ENV = ENVIRONMENT;

  public auth = inject(AuthService);
  private router = inject(Router);

  public async logout() {
    await this.auth.logout();
    this.router.navigate(["/loggedout"]);
  }

  public customLogoURLRoleCheck(test: any) {
    return test.some((url: any) => url.roles.includes(this.auth.roleName));
  }
}
